var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.dataLoad,
          expression: "dataLoad",
        },
      ],
      ref: _vm.componentRef,
      staticClass:
        "data-view-item-wrap ds-control data-view-scroll-digital data-view-no-padding",
      style: _vm.controlStyle,
      attrs: {
        "element-loading-text": _vm.loadingText,
        "element-loading-spinner": _vm.loadingSpinner,
        "element-loading-background": _vm.loadingBackground,
      },
      on: { click: _vm.clickItem },
    },
    [
      _vm._t(
        "default",
        function () {
          return [
            _vm.isTotalDigital
              ? _c(
                  "div",
                  {
                    staticClass: "split-digital-item split-digital-item-total",
                    style: _vm.splitDigitalItemStyle,
                  },
                  [
                    (_vm.isPrefix || _vm.config.prefix) && _vm.nowData
                      ? _vm._t(
                          "prefix",
                          function () {
                            return [
                              _vm.isPrefix
                                ? [
                                    _c(
                                      "span",
                                      { style: _vm.getPrefixStyle },
                                      [
                                        _vm.getPrefixStyle.other.showType ===
                                        "icon"
                                          ? [
                                              _c("i", {
                                                class:
                                                  "common-icon iconfont icon-" +
                                                  _vm.getPrefixStyle.other.icon,
                                              }),
                                            ]
                                          : _vm.getPrefixStyle.other
                                              .showType === "img" &&
                                            _vm.getPrefixStyle.other.imgObj
                                          ? [
                                              _c("img", {
                                                staticClass: "common-img",
                                                attrs: {
                                                  src: _vm.handleImgSrcStr(
                                                    _vm.getPrefixStyle.other
                                                      .imgObj.src
                                                  ),
                                                  width:
                                                    _vm.getPrefixStyle.other
                                                      .imgObj.width,
                                                  height:
                                                    _vm.getPrefixStyle.other
                                                      .imgObj.height,
                                                },
                                              }),
                                            ]
                                          : [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.handleExpressionContent(
                                                      _vm.getPrefixStyle.other
                                                        .content,
                                                      _vm.nowData
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                : _vm.config.prefix
                                ? _c("span", { style: _vm.fontFixStyle }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.config.prefix) + " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                          {
                            info: _vm.getPrefixStyle,
                            row: _vm.nowData,
                            config: _vm.config,
                          }
                        )
                      : _vm._e(),
                    _vm._v("  " + _vm._s(_vm.displayValue) + "  "),
                    (_vm.isSuffix || _vm.config.suffix) && _vm.nowData
                      ? _vm._t(
                          "suffix",
                          function () {
                            return [
                              _vm.isSuffix
                                ? [
                                    _c(
                                      "span",
                                      { style: _vm.getSuffixStyle },
                                      [
                                        _vm.getSuffixStyle.other.showType ===
                                        "icon"
                                          ? [
                                              _c("i", {
                                                class:
                                                  "common-icon iconfont icon-" +
                                                  _vm.getSuffixStyle.other.icon,
                                              }),
                                            ]
                                          : _vm.getSuffixStyle.other
                                              .showType === "img" &&
                                            _vm.getSuffixStyle.other.imgObj
                                          ? [
                                              _c("img", {
                                                staticClass: "common-img",
                                                attrs: {
                                                  src: _vm.handleImgSrcStr(
                                                    _vm.getSuffixStyle.other
                                                      .imgObj.src
                                                  ),
                                                  width:
                                                    _vm.getSuffixStyle.other
                                                      .imgObj.width,
                                                  height:
                                                    _vm.getSuffixStyle.other
                                                      .imgObj.height,
                                                },
                                              }),
                                            ]
                                          : [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.handleExpressionContent(
                                                      _vm.getSuffixStyle.other
                                                        .content,
                                                      _vm.nowData
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                : _vm.config.suffix
                                ? _c("span", { style: _vm.fontFixStyle }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.config.suffix) + " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                          {
                            info: _vm.getSuffixStyle,
                            row: _vm.nowData,
                            config: _vm.config,
                          }
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _c(
                  "div",
                  { staticClass: "split-digital", style: _vm.fontStyle },
                  [
                    (_vm.isPrefix || _vm.config.prefix) && _vm.nowData
                      ? _vm._t(
                          "prefix",
                          function () {
                            return [
                              _vm.isPrefix
                                ? _c(
                                    "span",
                                    { style: _vm.getPrefixStyle },
                                    [
                                      _vm.getPrefixStyle.other.showType ===
                                      "icon"
                                        ? [
                                            _c("i", {
                                              class:
                                                "common-icon iconfont icon-" +
                                                _vm.getPrefixStyle.other.icon,
                                            }),
                                          ]
                                        : _vm.getPrefixStyle.other.showType ===
                                            "img" &&
                                          _vm.getPrefixStyle.other.imgObj
                                        ? [
                                            _c("img", {
                                              staticClass: "common-img",
                                              attrs: {
                                                src: _vm.handleImgSrcStr(
                                                  _vm.getPrefixStyle.other
                                                    .imgObj.src
                                                ),
                                                width:
                                                  _vm.getPrefixStyle.other
                                                    .imgObj.width,
                                                height:
                                                  _vm.getPrefixStyle.other
                                                    .imgObj.height,
                                              },
                                            }),
                                          ]
                                        : [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.handleExpressionContent(
                                                    _vm.getPrefixStyle.other
                                                      .content,
                                                    _vm.nowData
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ],
                                    ],
                                    2
                                  )
                                : _vm.config.prefix
                                ? _c("span", { style: _vm.fontFixStyle }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.config.prefix) + " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                          {
                            info: _vm.getPrefixStyle,
                            row: _vm.nowData,
                            config: _vm.config,
                          }
                        )
                      : _vm._e(),
                    _vm._l(_vm.splitValue, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "split-digital-item",
                          class: {
                            "split-digital-symbol": !_vm.isNumber(item),
                          },
                          style: _vm.splitDigitalItemStyle,
                        },
                        [_vm._v(" " + _vm._s(item) + " ")]
                      )
                    }),
                    (_vm.isSuffix || _vm.config.suffix) && _vm.nowData
                      ? _vm._t(
                          "suffix",
                          function () {
                            return [
                              _vm.isSuffix
                                ? [
                                    _c(
                                      "span",
                                      { style: _vm.getSuffixStyle },
                                      [
                                        _vm.getSuffixStyle.other.showType ===
                                        "icon"
                                          ? [
                                              _c("i", {
                                                class:
                                                  "common-icon iconfont icon-" +
                                                  _vm.getSuffixStyle.other.icon,
                                              }),
                                            ]
                                          : _vm.getSuffixStyle.other
                                              .showType === "img" &&
                                            _vm.getSuffixStyle.other.imgObj
                                          ? [
                                              _c("img", {
                                                staticClass: "common-img",
                                                attrs: {
                                                  src: _vm.handleImgSrcStr(
                                                    _vm.getSuffixStyle.other
                                                      .imgObj.src
                                                  ),
                                                  width:
                                                    _vm.getSuffixStyle.other
                                                      .imgObj.width,
                                                  height:
                                                    _vm.getSuffixStyle.other
                                                      .imgObj.height,
                                                },
                                              }),
                                            ]
                                          : [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.handleExpressionContent(
                                                      _vm.getSuffixStyle.other
                                                        .content,
                                                      _vm.nowData
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                : _vm.config.suffix
                                ? _c("span", { style: _vm.fontFixStyle }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.config.suffix) + " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                          {
                            info: _vm.getSuffixStyle,
                            row: _vm.nowData,
                            config: _vm.config,
                          }
                        )
                      : _vm._e(),
                  ],
                  2
                ),
          ]
        },
        {
          prefix: _vm.config.prefix,
          data: _vm.displayValue,
          suffix: _vm.config.suffix,
          row: _vm.nowData,
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }